/**
 * SpinLoader Component.
 * Wrapper of Kepler `Loader` Component.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { contentBoxStyle, Loader } from 'kepler';

const SpinLoader = ({ show }) => (
  <div style={contentBoxStyle}>
    <Loader show={show} priority={10} type="fixed" />
  </div>
);

// SpinLoader Props Types.
SpinLoader.propTypes = {
  show: PropTypes.bool.isRequired,
};

// SpinLoader Props default values.
SpinLoader.defaultProps = {
  show: false,
};

export default SpinLoader;



// WEBPACK FOOTER //
// ./contactUs/components/common/SpinLoader.js